import AppLogo from "@/components/AppLogo";
import { ButtonSolid } from "@intrasys/core-ui";
import { sendEmail } from "@/utils/functions";
import illustration from "@/assets/img/illustrations/undraw_fixing_bugs_w7gi.svg";
interface AppErrorProps {
  handleCallback?: () => void;
  message?: string;
}

const AppError = ({ handleCallback }: AppErrorProps) => {
  return (
    <div className="grid min-h-full place-items-center px-6 py-24 sm:py-32 lg:px-8">
      <AppLogo className="mb-10 justify-center" />
      <div className="text-center">
        <p className="text-3xl font-semibold text-primary-600">FE-500</p>
        <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-5xl">
          Something went wrong
        </h1>
        <div className="flex justify-center">
          <img src={illustration} className="h-60 w-60" />
        </div>
        <p className="mt-6 text-base leading-7 text-gray-600 dark:text-gray-500">
          Sorry, we had some technical problems during your last operation.
        </p>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <ButtonSolid
            label="Retry"
            onClick={() => (handleCallback ? handleCallback() : null)}
          />
          <ButtonSolid
            label="Contact Support"
            variant={"alternative"}
            onClick={() => {
              sendEmail({
                emailId: "intrasys@support.com.sg",
                from: "Support Team",
                subject: "FE-500 error",
              });
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AppError;
